import { render, staticRenderFns } from "./FundProjectModal.vue?vue&type=template&id=74d4945b&scoped=true&"
import script from "./FundProjectModal.vue?vue&type=script&lang=js&"
export * from "./FundProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./FundProjectModal.vue?vue&type=style&index=0&id=74d4945b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d4945b",
  null
  
)

export default component.exports